import * as React from 'react';

import { IModuleProps } from '../../core/utils/modules';
import CompositeField from '../components/CompositeField';

const NEW_CUSTOMER_INFO_REQUIRED_SUBFIELDS = ['name', 'country', 'postalCode', 'city', 'vat', 'language'];
const NEW_CUSTOMER_INFO_OPTIONAL_SUBFIELDS = ['street', 'houseNumber', 'phoneNumber', 'email', 'stateRegion'];
const NEW_CUSTOMER_INFO_ALL_SUBFIELDS = [
    ...NEW_CUSTOMER_INFO_REQUIRED_SUBFIELDS,
    ...NEW_CUSTOMER_INFO_OPTIONAL_SUBFIELDS,
];

export default {
    name: 'syskomp',
    components: {
        // Add custom components here
        Field: [
            {
                condition: ({ fieldName }) => fieldName === 'new_customer_info',
                component: (props: any) => {
                    // The backend's generic reset-field action isn't dynamic_schema-aware and silently
                    // no-ops for any composite field's subfields (a core bug, not specific to this field).
                    // This field has no meaningful "originally extracted" value to revert to anyway (it's
                    // always manually typed in), so Reset here just clears every subfield to empty via the
                    // normal per-subfield update path, which works correctly.
                    const clearAllSubfields = () => {
                        const emptyPayload = Object.fromEntries(
                            NEW_CUSTOMER_INFO_ALL_SUBFIELDS.map((key) => [key, ''])
                        );
                        props.onValueChange?.(emptyPayload);
                        return props.onCommit?.(emptyPayload);
                    };

                    return (
                        <CompositeField
                            {...props}
                            requiredSubfields={NEW_CUSTOMER_INFO_REQUIRED_SUBFIELDS}
                            summaryValueField="summaryText"
                            onReset={clearAllSubfields}
                        />
                    );
                },
            },
        ],
    },
} as IModuleProps;
